import { Injectable } from '@angular/core';
import { Commands } from '@local/client-contracts';
import { isNativeWindow } from '@local/common-web';
import { Shortcuts } from '@shared/services/keyboard.service';
import { KeyName } from '@local/ts-infra';
import { ResultContextMenuItem } from '../../results/models/results-types';
import { ResultCommandBuilder, ResultCommandBuilderParams } from '../../results/services/result-command-builder.service';

@Injectable({
  providedIn: 'root',
})
export class GoLinkCommandBuilder extends ResultCommandBuilder {
  isNative = isNativeWindow();

  async build(params: GoLinkCommandBuilderParams): Promise<ResultContextMenuItem[]> {
    const items: ResultContextMenuItem[] = await super.build({
      resourceId: params.resourceId,
      open: params.open,
      isFavorite: params.isFavorite,
      copy: params?.copy,
      dynamicCommands: params.dynamicCommands,
      removeCommands: params.removeCommands,
    });
    const shortcuts: ResultShortcuts = await this.keyboardService.loadShortcuts<ResultShortcuts>(['_home', '_goLink']);
    if (params?.copyGoLink) {
      items.splice(1, 0, {
        id: 'copy_goLink',
        text: `Copy Go Link`,
        command: { type: 'copy-clipboard', value: params?.copyGoLink.value } as Commands.CopyClipboard,
        shortcut: this.isNative ? <KeyName[]>shortcuts.copyGoLink.map((k) => k.toLowerCase()) : null,
        icon: { type: 'font-icon', value: 'icon-copy1' },
      });
    }

    if (params?.share) {
      items.push({
        id: 'share_goLink',
        text: `Share`,
        command: { type: 'go-links-share' },
        icon: { type: 'font-icon', value: 'icon-members' },
      });
    }

    if (params?.edit) {
      items.push({
        id: 'edit_goLink',
        text: `Edit`,
        command: { type: 'go-links-edit' },
        shortcut: this.isNative ? <KeyName[]>shortcuts.edit.map((k) => k.toLowerCase()) : null,
        icon: { type: 'font-icon', value: 'icon-pencil5' },
      });
    }

    if (params?.delete) {
      items.push({
        id: 'delete_goLink',
        text: `Delete`,
        command: { type: 'go-links-delete' },
        shortcut: this.isNative ? <KeyName[]>shortcuts.delete.map((k) => k.toLowerCase()) : null,
        icon: { type: 'font-icon', value: 'icon-delete' },
      });
    }
    
    return items;
  }
}

export type KeyValue = { key?: string; value?: string };
export interface GoLinkCommandBuilderParams extends ResultCommandBuilderParams {
  copyGoLink: KeyValue;
  edit?: KeyValue;
  delete?: KeyValue;
  share?: KeyValue;
}
export interface ResultShortcuts extends Shortcuts {
  edit: string[];
  delete: string[];
  copyGoLink: string[];
}
